import { CALLING_COMPONENT } from 'navigation-components/config';
import { useToggleComponent } from 'navigation-components/platform/hooks';
import { useRef } from 'react';
import memoWithDisplayName from '../../../utils/memoWithDisplayName';
import { useCloseCallRemoteOnOutsideClick } from '../hooks';
import { useTranslation } from '../../../hooks/useNavConfig';
import { CallIconWithStatus } from './CallIconWithStatus';
import styled, { css } from 'styled-components';
import { navTheme } from '../../../theme/nav-theme';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledToggleButton = styled.button.withConfig({
  displayName: "CallingNavComponentIcon__StyledToggleButton",
  componentId: "sc-1jhh0f9-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return css(["background:transparent;padding:8px;border-radius:6px;border-style:none;&:hover{background:", ";}"], navTheme(theme).navBgSecondary);
});
export const CallingNavComponentIcon = memoWithDisplayName('CallingNavComponentIcons', () => {
  const {
    t
  } = useTranslation();
  const callIconRef = useRef(null);
  useCloseCallRemoteOnOutsideClick(callIconRef);
  const {
    toggle: toggleCallingComponent
  } = useToggleComponent(CALLING_COMPONENT);
  return /*#__PURE__*/_jsx(StyledToggleButton, {
    ref: callIconRef,
    "aria-label": t('nav.other.calling.button.label'),
    onClick: () => toggleCallingComponent(),
    "data-onboarding": "calling-remote",
    "data-selenium-test": "call-remote-toggle",
    id: "calling-remote-toggle",
    children: /*#__PURE__*/_jsx(CallIconWithStatus, {})
  });
});